import { Navigate, BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Vente from "@/pages/Vente";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Drive from "@/pages/Drive";
import "@/App.css";

function CaseNormalizer() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const lower = location.pathname.toLowerCase();
    if (location.pathname !== lower) {
      navigate(lower + location.search + location.hash, { replace: true });
    }
  }, [location, navigate]);
  return null;
}

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="font-mono-data text-xs text-neutral-400">
          Vérification…
        </span>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <CaseNormalizer />
        <Routes>
          <Route path="/" element={<Navigate to="/vente" replace />} />
          <Route path="/vente" element={<Vente />} />
          <Route path="/admin/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/drive"
            element={
              <ProtectedRoute>
                <Drive />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/vente" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: "0px",
            border: "1px solid #0a0a0a",
            background: "#fff",
            color: "#0a0a0a",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
